import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import Select from 'components/ui/SelectField';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';

const PermissionToAbsentEnterSelect = ({ setFieldValue, value, errors, touched, disabled }) => {
  return (
    <Col span={12}>
      <Form.Item
        label={`${getTranslatedString('landlordPortal.maintenance.permissionAbsent')}*`}
        validateStatus={
          touched.consent_to_entry_while_away && errors.consent_to_entry_while_away ? 'error' : null
        }
        help={touched.consent_to_entry_while_away && errors.consent_to_entry_while_away}
      >
        <Select
          placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.select')}
          size="large"
          value={value}
          disabled={disabled}
          onChange={value => {
            setFieldValue('consent_to_entry_while_away', value);
          }}
        >
          <Select.Option value={true}>{getTranslatedString('request_type.yes')}</Select.Option>
          <Select.Option value={false}>{getTranslatedString('request_type.no')}</Select.Option>
        </Select>
      </Form.Item>
    </Col>
  );
};

export default PermissionToAbsentEnterSelect;
